export const OptionKey = {
  EDIT: 'edit',
  DELETE: 'delete',
};
